import { MenuItem, TextField } from "@mui/material";
import { levelLabels } from "../access-model";

import type { Level } from "../access-model";
import type { FC } from "react";

const levels: Level[] = ["none", "read", "edit"];

/** A level picker. A change is saved straight away by the caller. */
export const LevelSelect: FC<{
  label: string;
  level: Level;
  disabled?: boolean;
  onChange: (level: Level) => void;
}> = ({ label, level, disabled = false, onChange }) => (
  <TextField
    select
    size="small"
    value={level}
    disabled={disabled}
    onChange={(e) => {
      const value = levels.find((option) => option === e.target.value);
      if (value) onChange(value);
    }}
    slotProps={{ select: { SelectDisplayProps: { "aria-label": label } } }}
    sx={{ minWidth: 168 }}
  >
    {levels.map((option) => (
      <MenuItem key={option} value={option}>
        {levelLabels[option]}
      </MenuItem>
    ))}
  </TextField>
);
